import { create } from "zustand";
import type { RawBusiness } from "../types/business";

const getStoredBusinesses = (): RawBusiness[] => {
  try {
    const businesses = JSON.parse(
      localStorage.getItem("connected_businesses") || "[]",
    );
    if (Array.isArray(businesses) && businesses.length > 0) return businesses;

    const single = JSON.parse(
      localStorage.getItem("selected_business") || "null",
    );
    return single ? [single] : [];
  } catch {
    return [];
  }
};

const getStoredActiveBusiness = (): RawBusiness | null => {
  try {
    return JSON.parse(localStorage.getItem("selected_business") || "null");
  } catch {
    return null;
  }
};

interface BusinessState {
  connectedBusinesses: RawBusiness[];
  activeBusiness: RawBusiness | null;
  setConnectedBusinesses: (businesses: RawBusiness[]) => void;
  setActiveBusiness: (business: RawBusiness | null) => void;
}

const useBusinessStore = create<BusinessState>((set) => ({
  connectedBusinesses: getStoredBusinesses(),
  activeBusiness: getStoredActiveBusiness(),

  setConnectedBusinesses: (businesses) => {
    localStorage.setItem("connected_businesses", JSON.stringify(businesses));
    set({ connectedBusinesses: businesses });
  },

  setActiveBusiness: (business) => {
    if (business) {
      localStorage.setItem("selected_business", JSON.stringify(business));
    } else {
      localStorage.removeItem("selected_business");
    }
    set({ activeBusiness: business });
  },
}));

export default useBusinessStore;
